import { duplicateTable } from './types';
/**
 *
 *
 * dataset-> $connections(IConnection[]) #list_of_selected_connection
 *
 * dataset-> $database({
 * [connectionId]:value}) #selected_databse_of_connection
 *
 * dataset-> $schema({
 * [connectionId]:value} ##selected_schema_of_connection
 *
 * dataset-> $selectedConnectionId #Id_of_selected_connection
 *
 * dataset-> $views(IView[]) #list_of_views_of_current_connection
 *
 * dataset->$tables(ITable[]) #list_of_tables_of_current_connection
 *
 * dataset->$selectedTables(ISelectedTables[]) #list_of_selected_tables_accross_connection
 */
import update from 'immutability-helper';
import { TAction, IDatasetState, ITable } from './types';
import ShortUniqueId from 'short-unique-id';
import { reverseCardinality, reverseIntegrity } from '../../Components/_dataset/utils';

const defaultValue: IDatasetState = {
  connections: [],
  database: {},
  schema: {},
  selectedConnectionId: '',
  views: [],
  tables: [],
  selectedTables: [],
  canEdit: true,
  arrows: [],
  isExtract: false,
  datasetName: '',
  datasetId: '',
};
const DataSetReducer = (state: IDatasetState = defaultValue, action: TAction) => {
  switch (action.type) {
    case 'LOAD':
      return action.payload;
    case 'RESET':
      return defaultValue;
    case 'UPDATE_CONNECTIONS':
      return update(state, {
        connections: { $set: action.payload },
        selectedConnectionId: { $set: null },
      });
    case 'UPDATE_DB':
      return update(state, {
        database: {
          [action.payload.connectionId]: {
            $set: action.payload.db,
          },
        },
      });
    case 'UPDATE_SCHEMA':
      return update(state, {
        schema: {
          [action.payload.connectionId]: {
            $set: action.payload.schema,
          },
        },
      });
    case 'SELECT_CONNECTION':
      return update(state, {
        selectedConnectionId: { $set: action.payload },
      });
    case 'SET_SELECTED_TABLES':
      return update(state, {
        selectedTables: { $set: action.payload },
      });
    case 'SET_IS_EXTRACT':
      return update(state, {
        isExtract: { $set: action.payload },
      });
    case 'ADD_ARROWS':
      return update(state, { arrows: { $push: [action.payload] } });

    case 'REMOVE_ARROW':
      return update(state, {
        arrows: {
          $set: state.arrows.filter((arrow) => !action.payload.includes(arrow.arrowId)),
        },
      });

    case 'SET_DATASET_NAME':
      return update(state, {
        datasetName: { $set: action.payload },
      });
    case 'UPDATE_ALL_ARROWSIN_RELATION':
      const { relationId, cardinality, integrity,showHead, showTail,startTableId, endTableId } = action.payload;

      const new_arrows = state.arrows.map((arrow) => {
        if (arrow.relationId !== relationId) return arrow;

        const isOppositeDir =
          arrow.startId === endTableId &&
          arrow.endId === startTableId;

        return {
          ...arrow,
          cardinality: isOppositeDir ? reverseCardinality(cardinality) : cardinality,
          integrity: isOppositeDir ? reverseIntegrity(integrity) : integrity, 
          showHead,
          showTail,
        };
      });
      return update(state, {
        arrows: { $set: new_arrows },
      });

    case 'DUPLICATE_TABLE':
      const { tableId, newId, alias } = action.payload;
      const uid = new ShortUniqueId({ length: 4 });
      const table = state.selectedTables.find((table) => table.id === tableId);
      if (!table) return state;
      // generating new table id in the format originalId_newid
      const newTableId = table.isDuplicated
        ? `${table.id.split('_')[0]}_${newId}`
        : `${table.id}_${newId}`;
      const duplicateTableColumns = table.columns.map((col) => ({
        ...col,
        uid: uid(),
      }));
      //duplicate table id will be original table id + newid(uniq new id)
      const duplicateTableData = {
        ...table,
        id: newTableId,
        alias,
        columns: duplicateTableColumns,
        tablePositionX: table.tablePositionX + 10,
        tablePositionY: table.tablePositionY + 10,
        isDuplicated: true,
        isNewTable: true,
      };
      return update(state, {
        selectedTables: {
          $push: [duplicateTableData],
        },
      });

    default:
      return state;
  }
};
export default DataSetReducer;
